/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Restore_Event_GroupsInputs */

const en_restore_event_groups = /** @type {(inputs: Restore_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore Event Groups`)
};

const fr_restore_event_groups = /** @type {(inputs: Restore_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurer les groupes d'événements`)
};

const de_restore_event_groups = /** @type {(inputs: Restore_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppen wiederherstellen`)
};

const it_restore_event_groups = /** @type {(inputs: Restore_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripristina gruppi di eventi`)
};

const ru_restore_event_groups = /** @type {(inputs: Restore_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восстановить группы событий`)
};

const es_restore_event_groups = /** @type {(inputs: Restore_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar grupos de eventos`)
};

const zh_cn2_restore_event_groups = /** @type {(inputs: Restore_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恢复事件组`)
};

const ja_restore_event_groups = /** @type {(inputs: Restore_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループを復元する`)
};

const hi_restore_event_groups = /** @type {(inputs: Restore_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूहों को पुनर्स्थापित करें`)
};

const pt_pt2_restore_event_groups = /** @type {(inputs: Restore_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar grupos de eventos`)
};

/**
* | output |
* | --- |
* | "Restore Event Groups" |
*
* @param {Restore_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const restore_event_groups = /** @type {((inputs?: Restore_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Restore_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_restore_event_groups(inputs)
	if (locale === "de") return de_restore_event_groups(inputs)
	if (locale === "it") return it_restore_event_groups(inputs)
	if (locale === "ru") return ru_restore_event_groups(inputs)
	if (locale === "es") return es_restore_event_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_restore_event_groups(inputs)
	if (locale === "ja") return ja_restore_event_groups(inputs)
	if (locale === "hi") return hi_restore_event_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_restore_event_groups(inputs)
	return en_restore_event_groups(inputs)
});